import { safeParseJSON } from './helpers';

declare const chrome: any;

export const saveToLocal = (name: string, data: any) => {
  localStorage.setItem(name, JSON.stringify(data));
};
export const saveToChromeStorage = (name: string, data: any) => {
  if (typeof chrome !== 'undefined' && chrome.storage) {
    chrome.storage.local.set({ [name]: data }, function () {});
  } else {
    console.warn('Chrome storage is not available. Falling back to localStorage.');
    saveToLocal(name, data);
  }
};

export const getFromLocal = (name: string) => {
  let value: any = localStorage.getItem(name);
  value = safeParseJSON(value);
  return value && value !== 'undefined' && value !== 'null' ? value : null;
};
export const getFromChromeStorage = (name: string) => {
  return new Promise((resolve, reject) => {
    chrome.storage.local.get([name], function (result: any) {
      if (chrome.runtime.lastError) {
        reject(chrome.runtime.lastError);
        console.log(`error trying to get ${name}`);
      } else {
        resolve(result[name]);
      }
    });
  });
};
